module.exports = __webpack_public_path__ + "static/media/Artboard 1 copy 108.e27374a2.png";